import theme from '../base'

const badge = {
  MuiBadge: {
    styleOverrides: {
      badge: {
        fontWeight: 'bold',
        height: theme.spacing(2.25),
        minWidth: theme.spacing(2.25),
      },
    },
  },
}

export default badge
